import { h, render } from 'preact'
import { BandeSecondContrat } from '../../components/bande-second-contrat/bande-second-contrat.jsx'
import { secondContractDataFormatter } from '../dataFormatter/secondContractDataFormatter.js'
import { isEmptyObject } from '../modules/utilities.js'
import { SG1Logs } from '../modules/logs.js'

export const secondContractOrchestrator = (getAdvise) => {
   let SSEPromisesResolve
   const secondContratDataProviderSSE = new Promise((resolve, reject) => {
      SSEPromisesResolve = resolve
      // resolve(event.data) // Use this in dev
   })

   Promise.all([secondContratDataProviderSSE, getAdvise])
      .then((value) => {
         let sseDatas = value && value[0] && value[0].zones && value[0].zones[0] && value[0].zones[0].data ? value[0].zones[0].data : {}

         let adviseDatas = value && value[1] && value[1].reducedDatas ? value[1].reducedDatas : {}
         window.dataStoreHP.bandes.secondContract = secondContractDataFormatter(sseDatas, adviseDatas)
         if (isEmptyObject(window.dataStoreHP.bandes.secondContract) === false) {
            render(<BandeSecondContrat {...window.dataStoreHP.bandes.secondContract} />, document.getElementById('bandeSecondContrat'))
         }
      })
      .catch((error) => {
         console.error('Second Contrat', error)
         SG1Logs.incLog('Err_CORCH')
         SG1Logs.sentryEvent({ error: error, name: 'Second Contrat Orchestrator' })
      })
   return SSEPromisesResolve
}
